export const VUEX_STATISTICS_SEND = 'VUEX_STATISTICS_SEND'
